import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="dynamic-textarea"
export default class extends Controller {
  static targets = ['textarea']

  connect() {
    this.adjustHeight()
  }

  adjustHeight() {
    // 初期表示で隠れている場合は高さが0になるため調整をしない
    if (!this.textareaTarget.scrollHeight) return false

    const borderWidth = this.textareaTarget.offsetHeight - this.textareaTarget.clientHeight
    this.textareaTarget.style.height = 'auto'
    this.textareaTarget.style.height = `${this.textareaTarget.scrollHeight + borderWidth}px`
  }
}
